"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIteratorOpcodeTemplates = getIteratorOpcodeTemplates;
function getIteratorOpcodeTemplates() {
    return `
                        // Iterator Operations
                        case opMap[127]: { // GET_ITERATOR
                            // Get iterator from iterable using Symbol.iterator
                            // Stack: [iterable] -> [iterator]
                            let iterableForIterator = stack.pop();
                            if (iterableForIterator == null) {
                                throw new TypeError('Cannot iterate over ' + iterableForIterator);
                            }
                            let iteratorMethod = iterableForIterator[Symbol.iterator];
                            if (typeof iteratorMethod !== 'function') {
                                throw new TypeError('Object is not iterable');
                            }
                            stack.push(iteratorMethod.call(iterableForIterator));
                            pc++;
                            break;
                        }

                        case opMap[123]: { // ITERATOR_NEXT
                            // Call iterator.next() to get next value
                            // Stack: [iterator] -> [result]
                            let iteratorForNext = stack.pop();
                            let nextResult = iteratorForNext.next();
                            stack.push(nextResult);
                            pc++;
                            break;
                        }

                        case opMap[128]: { // ITERATOR_DONE
                            // Check if iterator result is done
                            // Stack: [result] -> [done] (boolean)
                            let iterResult = stack.pop();
                            stack.push(!!iterResult.done);
                            pc++;
                            break;
                        }
    `;
}
